import type { ReactNode } from 'react';
import { useSidebarOpenState } from '@backstage/core-components';
import { useManewcoTokens } from '@platform/plugin-platform-react';

interface Props {
  label: string;
  /** Conservé pour compatibilité : les sections de la maquette ne se replient plus. */
  defaultCollapsed?: boolean;
  children: ReactNode;
}

/**
 * Titre de section du menu (maquette « Clarté complète ») : petites capitales, fixe. Les groupes
 * repliables sont dans les sections (SidebarExpandableGroup). Menu replié en rail : pas de titre.
 */
export const SidebarCollapsibleSection = ({ label, children }: Props) => {
  const { isOpen } = useSidebarOpenState();
  const MANEWCO = useManewcoTokens();
  if (!isOpen) return <>{children}</>;
  return (
    <>
      <div
        style={{
          margin: '24px 24px 10px',
          color: MANEWCO.navHeading,
          fontFamily: MANEWCO.fontFamily,
          fontSize: 9,
          fontWeight: 700,
          letterSpacing: 1.8,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </div>
      {children}
    </>
  );
};
